import { useState } from 'react';
import { redirect } from 'react-router';
import '../styles/age-verification.css';

export default function AgeVerificationModal({ onVerified }) {

  const [denied, setDenied] = useState(false);
  if (denied) window.location.href = "https://google.com";

  return (
    <div className="age-overlay">
      <div className="age-modal">
        <div className="age-modal__logo">FLESHLIGHT VIP</div>
        <h2 className="age-modal__title">Age Verification</h2>
        <p className="age-modal__subtitle">
          This website contains adult content. You must be 18 years of age or
          older to enter.
        </p>
          <div className="age-modal__actions">
            <button className="age-modal__btn age-modal__btn--yes" onClick={onVerified}>
              Yes, I am 18+
            </button>
            <button className="age-modal__btn age-modal__btn--no" onClick={() => setDenied(true)}>
              Leave
            </button>
          </div>
      </div>
    </div>
  );
}